import { Dialog as NovaBaseDialog, DialogProps as NovaDialogProps } from '@fme-nova/components'
import { Dialog as MuiBaseDialog, DialogProps as MuiDialogProps, styled } from '@mui/material'
import React from 'react'

import { createComponentWrapperWithRef } from '../../theme'
import { Z_INDEX } from '../../theme'

const StyledMuiDialog = styled(MuiBaseDialog)`
  z-index: ${Z_INDEX.modal};
  .MuiDialog-paper {
    border-radius: 8px;
    max-width: unset;
  }
`

const StyledNovaDialog = styled(NovaBaseDialog)``

const maxWidthToMui = {
  xSmall: 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  xLarge: 'xl',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
} as const

function getMuiMaxWidth(maxWidth: NovaDialogProps['maxWidth']): MuiDialogProps['maxWidth'] {
  if (maxWidth === false || maxWidth === undefined) return maxWidth
  return maxWidthToMui[maxWidth]
}

const MuiDialog = React.forwardRef<HTMLDivElement, NovaDialogProps>(function MuiDialog(
  { maxWidth, variant: _variant, ...props },
  ref,
) {
  return <StyledMuiDialog {...props} ref={ref} maxWidth={getMuiMaxWidth(maxWidth)} />
})

const NovaDialog = React.forwardRef<HTMLDivElement, NovaDialogProps>(function NovaDialog(props, ref) {
  return <StyledNovaDialog {...props} ref={ref} maxWidth={props.maxWidth ?? false} />
})

export const Dialog = createComponentWrapperWithRef(
  {
    mui: MuiDialog,
    nova: NovaDialog,
  },
  'Dialog',
)
